import React, { useState } from "react";
import "../../styles/vars.scss";
import "../../styles/main.scss";
import "../../styles/compo.scss";
import CenterTitleZ from "../atoms/CenterTitleZ";
import ListCellZ from "../atoms/ListCellZ";
import SvgIcn from "../../data/IconCompo";

function CenterBarNav({ title, icon, text, children, selectedMode }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <button className={`center-bar-toggle ${selectedMode ? `${selectedMode}-bg` : 'white-bg'} ${isOpen ? 'sidebar-open' : ''}`} onClick={toggleSidebar}>
        <SvgIcn name={isOpen ? "side_out" : "side_in"} className="iconn" />
      </button>
      <div className={`center-bar-overlay ${isOpen ? 'active' : ''}`} onClick={toggleSidebar}></div>
      <div className={`center-bar-hero ${title === "Setting" ? 'settings' : ''} ${isOpen ? 'show' : ''}`}>
        <>{children}</>
      </div>
    </>
  );
}

export default CenterBarNav;